// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./FilterDropdown.Button.Dialog.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, ContainerPrimitive } from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const DialogContext = createContext(null);

function Dialog(_props) {
  const defaults = useContext(DialogContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="KzY3aHdSec"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "KzY3aHdSec",
        scope: "Gzpvh3r1oQ",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <ContainerPrimitive
          id={"Container_Bx813w86ap"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_Gzpvh3r1oQ_Bx813w86ap"
          }
          key={"Bx813w86ap"}
          addSpacing={false}
          element={getStyle("Bx813w86ap", "htmlElement")}
        >
          {
            <ContainerPrimitive
              key={"UsU6cGGzT2"}
              id={"Slot_UsU6cGGzT2"}
              className={
                "__visly_reset_7X7HTLRqyD __visly_scope_Gzpvh3r1oQ_UsU6cGGzT2"
              }
              addSpacing={false}
            >
              {props.children}
            </ContainerPrimitive>
          }
        </ContainerPrimitive>
      )}
    </RootPrimitive>
  );
}

Dialog.__variants = [];

export default Dialog;
